import React, {useState} from 'react'
import {humanFileSize} from '~/helpers/utils';
import {EllipseIcon} from '~/Components/Icons/Icons';
import Moment from "react-moment";
import {DownloadIcon} from "~/Components/Icons/Icons";
import {toggleArray} from "~/services/helpers";
import {Form} from "react-bootstrap";
import classnames from "classnames";

const AdminUploadList = ({uploads, selected = [], selectionChanged = null, eventHost = null}) => {

    const handleSelectedChange = (id) => {
        selectionChanged(toggleArray(selected, id));
    };

    return (
        <table className="table">

            <thead>
            <tr>
                {!eventHost && (
                    <th scope="col">#</th>
                )}
                <th scope="col">Upload Name</th>
                {!eventHost && (
                    <th scope="col">Host Name</th>
                )}
                <th scope="col">Size</th>
                <th scope="col">Upload Date</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
            </tr>
            </thead>

            <tbody>
            {uploads?.map((upload) => {

                let host = eventHost || upload.event_host;

                return (
                    <tr key={upload.id} className={classnames({'text-muted' : upload.archived_at})}>

                        {!eventHost && (
                            <td scope="row">
                                {!upload.archived_at && (
                                    <Form.Check
                                        key={upload.id}
                                        inline
                                        type="checkbox"
                                        id={'upload-' + upload.id}
                                        value={upload.id}
                                        checked={selected.indexOf(upload.id) >= 0}
                                        onClick={e => handleSelectedChange(upload.id)}
                                    />
                                )}
                            </td>
                        )}

                        <td>{upload.name}</td>
                        {!eventHost && (
                            <td>{host.host.full_name}</td>
                        )}
                        <td>{humanFileSize(upload.size)}</td>
                        <td><Moment format="DD/MM/YYYY h:mm:ss a" date={upload.created_at} /></td>
                        <td>

                            {!upload.actioned_at && !upload.archived_at && (
                                <span className="small mr-3">
                                    <EllipseIcon color="#EBAE45" classes="d-inline mr-1" /> New
                                </span>
                            )}

                            {upload.actioned_at && (
                                <span className="small mr-3" title={'Actioned at: ' + upload.actioned_at}>
                                    <EllipseIcon color="#44DE6F" classes="d-inline mr-1" /> Actioned
                                </span>
                            )}

                            {upload.archived_at && (
                                <span className="small mr-3" title={'Archived at: ' + upload.archived_at}>
                                    <EllipseIcon color="#D8DAE6" classes="d-inline mr-1" /> Archived
                                </span>
                            )}

                        </td>
                        <td>
                            <a href={upload.download_url}>
                                <DownloadIcon/>
                            </a>
                        </td>
                    </tr>
                );
            })}
            </tbody>
        </table>
    );
}

export default AdminUploadList;
